<template>
  <div v-if="po.offerSimulationRan">
    <div class="section-title">Simulim ndikimi ({{ po.offerSimulationAffected }})</div>
    <p v-if="po.offerSimulationRows.length && po.offerSimulationPreviewChunks.length" class="empty-note" style="margin-bottom: 12px">
      Produktet e ndikuara janë të grupuara sipas rregullave.
    </p>
    <div v-for="chunk in po.offerSimulationPreviewChunks" :key="chunk.key" class="sim-preview-chunk">
      <div v-if="chunk.kind === 'flat'" class="sim-preview-section">
        <div class="sim-preview-section-head">
          <span class="sim-preview-icon" :class="chunk.iconClass"><i :class="chunk.icon"></i></span>
          <div>
            <div class="sim-preview-section-title">{{ chunk.title }}</div>
            <div v-if="chunk.subtitle" class="sim-preview-section-sub">{{ chunk.subtitle }}</div>
          </div>
        </div>
        <div class="manual-table-wrap sim-sim-table-wrap">
          <table class="table is-fullwidth is-narrow sim-offer-sim-table">
            <thead>
              <tr>
                <th>Kodi</th>
                <th>Produkti</th>
                <th>Cmimi aktual</th>
                <th>Cmimi i ri</th>
                <th>Oferta fituese</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in chunk.rows" :key="`sim-${chunk.key}-${r.product_id}`">
                <td><code class="sim-code">{{ r.code }}</code></td>
                <td>{{ r.name }}</td>
                <td>{{ po.money(r.old_price) }}</td>
                <td class="sim-price-new">{{ po.money(r.new_price) }}</td>
                <td><span class="chip muted">{{ r.winner_campaign_code || "—" }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="chunk.kind === 'tree'" class="sim-preview-section sim-preview-tree-section">
        <div class="sim-preview-section-head">
          <span class="sim-preview-icon sim-preview-icon-tree"><i class="fa fa-sitemap"></i></span>
          <div>
            <div class="sim-preview-section-title">{{ chunk.title }}</div>
            <div class="sim-preview-section-sub sim-breadcrumb">{{ chunk.subtitle }}</div>
          </div>
        </div>
        <div v-for="grp in chunk.groups" :key="chunk.key + '-cat-' + grp.categoryKey" class="sim-tree-category-card">
          <div class="sim-tree-category-title">{{ grp.categoryTitle }}</div>
          <div class="manual-table-wrap sim-sim-table-wrap">
            <table class="table is-fullwidth is-narrow sim-offer-sim-table">
              <thead>
                <tr>
                  <th>Kodi</th>
                  <th>Produkti</th>
                  <th>Cmimi aktual</th>
                  <th>Cmimi i ri</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in grp.rows" :key="`sim-${chunk.key}-${grp.categoryKey}-${r.product_id}`">
                  <td><code class="sim-code">{{ r.code }}</code></td>
                  <td>{{ r.name }}</td>
                  <td>{{ po.money(r.old_price) }}</td>
                  <td class="sim-price-new">{{ po.money(r.new_price) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="po.offerSimulationRows.length === 0" class="empty-state">Nuk ka ndryshim cmimi me rregullat aktuale.</div>
  </div>
</template>

<script>
export default {
  name: "OfferSimulationPreview",
  inject: ["po"],
};
</script>
